import styles from "./pests-list.module.css";

type ListItem = {
  id: string;
  label: string;
  count: number;
  location?: string;
};

type PestsListProps = {
  title: string;
  total?: number;
  items: ListItem[];
  onItemClick?: (item: ListItem) => void;
};
export const PestsList = ({
  title,
  total,
  items,
  onItemClick,
}: PestsListProps) => {
  return (
    <div className={styles["pests-list"]}>
      <div className={styles["pests-list__o"]}>
        <span className={styles["pests-list__title"]}>{title}</span>

        <span className={styles["pests-list__title"]}>{total}</span>
      </div>
      {items.length === 0 ? (
        <span className={styles["pests-list__empty"]}>No pests found</span>
      ) : (
        <div className={styles["pests-list__list"]}>
          {items.map((item: ListItem) => (
            <ul
              key={item.id}
              className={styles["pests-list__item"]}
              onClick={() => onItemClick?.(item)}
              style={{ cursor: onItemClick ? "pointer" : "default" }}
            >
              <div className={styles["pests-list__content"]}>
                <div className={styles["pests-list__left"]}>
                  {item.location ? (
                    <span>
                      {item.label}, {item.location}
                    </span>
                  ) : (
                    <>
                      <span>{item.count}</span>

                      <span>{item.label}</span>
                    </>
                  )}
                </div>

                {item.location && (
                  <span className={styles["pests-list__title"]}>
                    {item.count}
                  </span>
                )}
              </div>
            </ul>
          ))}
        </div>
      )}
    </div>
  );
};
